export const TypeEntreprise = [
  'Inconnu',
  'Adherent',
  'Prestataire',
] as const

export type TypeEntreprise = typeof TypeEntreprise[number]

export const TypeEntrepriseLibelle: {
  [key in TypeEntreprise]: string
} = {
  Inconnu: 'Inconnu',
  Adherent: 'Adherent',
  Prestataire: 'Prestataire',
} as const
